var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeUserStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.808 13.2273L12.3475 12.7204C12.17 12.6951 12.0179 12.5936 11.9419 12.4162L10.0919 8.33504C9.73704 7.57452 8.67262 7.57452 8.3178 8.33504L6.46773 12.4162C6.39171 12.5938 6.23967 12.6951 6.06218 12.7204L1.57622 13.2273C0.739858 13.3286 0.410293 14.3427 1.01864 14.9004L4.33868 17.917C4.46544 18.0437 4.54146 18.2211 4.49072 18.3986L3.57833 22.784C3.40084 23.5952 4.28797 24.2289 4.99756 23.8233L8.92595 21.6433C9.07799 21.542 9.28076 21.542 9.43279 21.6433L13.3359 23.8739C14.0708 24.2795 14.9326 23.6458 14.7551 22.8345L13.8427 18.4492C13.8174 18.2717 13.868 18.069 13.9948 17.9675L17.3148 14.9509C17.9486 14.3427 17.6191 13.3286 16.808 13.2273Z",
    fill: "#FEAA01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17641 5.64706C9.93657 5.64706 10.5882 5.04299 10.5882 4.28119V1.36587C10.5882 0.604255 9.96381 0 9.17641 0C8.38921 0 7.76465 0.604067 7.76465 1.36587V4.28138C7.76465 5.04299 8.41626 5.64706 9.17641 5.64706Z",
    fill: "#7CD0D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5481 2.25066C16.8232 1.93493 15.9588 2.20205 15.6243 2.8335L14.2581 5.26182C13.9236 5.89314 14.2023 6.62163 14.9273 6.9374C15.1226 7.03446 15.3454 7.05885 15.5685 7.05885C16.0983 7.05885 16.6 6.79173 16.8511 6.35473L18.2173 3.92641C18.5518 3.31916 18.2451 2.56643 17.5481 2.25066Z",
    fill: "#7CD0D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78611 7.05884C3.00893 7.05884 3.20377 7.01012 3.42659 6.93713C4.15062 6.62071 4.42917 5.89078 4.09503 5.25792L2.73036 2.82435C2.39623 2.19166 1.53294 1.94826 0.808703 2.24025C0.0846696 2.55666 -0.193873 3.2866 0.140269 3.91946L1.50494 6.35303C1.75554 6.79116 2.25692 7.05884 2.78611 7.05884Z",
    fill: "#7CD0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeUserStar);
export default __webpack_public_path__ + "static/media/FreeUserStar.521d762162e59c3c7527f36a71c94c38.svg";
export { ForwardRef as ReactComponent };